// import { version } from '../../package.json';

export const environment = {
  production: true,
  version: '0.8.7'
};
